<template>
  <div>
    <div class="block w-full mb-4">

      <div class="grid grid-cols-2 gap-4 w-full">

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.name') }} *
          </div>
          <div class="inputField flex-grow" >
            <div :class="{ error: v$.name.$errors.length }">
              <input type="text" v-model="popupData.name" class="w-full" id="name" /><br/>
              <div class="input-errors" v-for="error of v$.name.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.email') }} *
          </div>
          <div class="inputField flex-grow" >
            <div :class="{ error: v$.email.$errors.length }">
              <input type="text" v-model="popupData.email" class="w-full" id="email" /><br/>
              <div class="input-errors" v-for="error of v$.email.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.street') }}
          </div>
          <div class="inputField flex-grow" >
            <input type="text" v-model="popupData.street" class="w-full" id="street" /><br/>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.houseNumber') }}
          </div>
          <div class="inputField flex-grow" >
             <input type="text" v-model="popupData.houseNumber" class="w-full" id="houseNumber" /><br/>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.postalcode') }}
          </div>
          <div class="inputField flex-grow" >
            <input type="text" v-model="popupData.postalcode" class="w-full" id="postalcode" /><br/>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.city') }}
          </div>
          <div class="inputField flex-grow" >
            <input type="text" v-model="popupData.city" class="w-full" id="city" /><br/>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.phoneNumber') }}
          </div>
          <div class="inputField flex-grow" >
            <div :class="{ error: v$.phoneNumber.$errors.length }">
              <input type="text" v-model="popupData.phoneNumber" placeholder="+4912345678" class="w-full" id="phoneNumber" /><br/>
              <div class="input-errors" v-for="error of v$.phoneNumber.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.latitude') }} *
          </div>
          <div class="inputField flex-grow" >
            <div :class="{ error: v$.latitude.$errors.length }">
              <input type="text" v-model="popupData.latitude" class="w-full" id="latitude" /><br/>
              <div class="input-errors" v-for="error of v$.latitude.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.longitude') }} *
          </div>
          <div class="inputField flex-grow" >
            <div :class="{ error: v$.longitude.$errors.length }">
              <input type="text" v-model="popupData.longitude" class="w-full" id="longitude" /><br/>
              <div class="input-errors" v-for="error of v$.longitude.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="inputTitle">
            {{ $t('plantManagment.popups.addOrUpdate.applicationRadius') }} *
          </div>
          <div class="inputField flex-grow" >
            <div :class="{ error: v$.applicationRadius.$errors.length }">
              <input type="text" v-model="popupData.applicationRadius" class="w-full" id="applicationRadius" /><br/>
              <div class="input-errors" v-for="error of v$.applicationRadius.$errors" :key="error.$uid">
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script setup>
import {computed, defineProps, onMounted, ref, toRef} from "vue";
import {useSystemStore} from "@/stores/system/SystemStore";
import {email, helpers, minValue, required} from "@vuelidate/validators";
import {useI18n} from "vue-i18n";
import useVuelidate from "@vuelidate/core";


const props = defineProps({
  data: Object
})
const popupData = toRef(props, 'data');

const systemStore = useSystemStore();
const { t } = useI18n();

const rules = computed(() => {
  return {
    name: { required: helpers.withMessage(t('validators.required'), required) },
    latitude: {
      required: helpers.withMessage(t('validators.required'), required),
      minValue: helpers.withMessage(t('validators.minValue'), minValue(0)),
    },
    longitude: {
      required: helpers.withMessage(t('validators.required'), required),
      minValue: helpers.withMessage(t('validators.minValue'), minValue(0)),
    },
    applicationRadius: {
      required: helpers.withMessage(t('validators.required'), required)
    },
    phoneNumber: {
      phoneNumbersValidator: helpers.withMessage(t('validators.phoneNumber'), helpers.regex(/^\+[0-9]+$/)),
    },
    email: {
      required: helpers.withMessage(t('validators.required'), required),
      email: helpers.withMessage(t('validators.email'), email),
    },
  }
})

const v$ = ref(useVuelidate(rules, popupData));

onMounted(()=>{
  systemStore.modal.validator = v$;
})
</script>